import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocalizeMessage, RadioGroup, RadioGroupOption } from 'libs.nucleus';
export const CreateViewOptionSelect = ({ selectedOption, onOptionChange }) => {
    const translate = useLocalizeMessage();
    const creationOptions = [
        {
            label: translate('Create a dataset'),
            description: translate('Build a dataset and save it to your library.'),
            value: 'create',
        },
        {
            label: translate('Clone a dataset'),
            description: translate('Clone and customize an existing dataset from your library.'),
            value: 'clone',
        },
    ];
    return (_jsx("div", { className: 'flex flex-col items-center justify-center size-full', children: _jsxs("div", { className: 'min-w-[50%] space-y-4', children: [_jsx("div", { className: 'text-lg font-semibold', children: translate('Select how you would like to get started') }), _jsx(RadioGroup, { value: selectedOption, onChange: onOptionChange, children: creationOptions.map((option) => (_jsx("div", { className: `w-full border rounded-lg p-5 cursor-pointer transition-colors ${selectedOption === option.value ? 'border-indigo-500' : 'border-gray-200 hover:border-gray-400'}`, children: _jsx(RadioGroupOption, { option: option }) }, option.value))) })] }) }));
};
